<template>
  <div class="tending-notice-detail">
    <div class="title-wrap">
      <div class="subtitle-wrap">
        <div class="title">
          新希望集团（室内公共区域装饰工程设计与施工）供应商招募
        </div>
        <div class="icon">
          <Icon :name="name" :status="0"></Icon>
        </div>
      </div>
      <div class="pubdate-wrap">
        <div class="date"><span>发布于：</span><span>2018</span></div>
        <div class="share-icon"></div>
      </div>
    </div>
    <recruitTitle title="中标详情"></recruitTitle>
    <div class="register-wrap">
      <div><span>所属公司：</span><span>2</span></div>
      <div><span>报名截止时间：</span><span>成都公司</span></div>
      <div><span>所属项目：</span><span>成都公司</span></div>
    </div>
    <div class="detail">
      <recruitTitle title="招标详情"></recruitTitle>
      <div class="detail-rest">
        <div class="title">
          温州三江立体城由万通立体之城与新希望地产携手共建占地760余亩，地上总建筑面积达180万方(其中商业有80万方)，地下总建筑面积70万方；位于永嘉县三江商务区，与温州大南门商圈一桥之隔，是集住宅、商业综合体、亚洲第一豪宅、5A写字楼、轻奢版概念公寓以及健康医疗产业、高级学校、希尔顿五星级酒店、观光旅游等城市产业为一体的立体微城市。打造温州北外滩
          “温州北” 江滨生态CBD打造温州陆家嘴、温州新名片 、经济新引擎
          、城市新中心。
        </div>
        <div class="item">
          <div class="item-info">
            <span>1、招标项目名称：</span
            >温州三江立体城由万通立体之城与新希望地产携。
          </div>
        </div>
        <div class="item">
          <div class="item-info">
            <span>2、招标项目名称：</span
            >温州三江立体城由万通立体之城与新希望地产携。
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="contract">
      <recruitTitle title='联系方式'></recruitTitle>
      <div class="contract-info">
        <div><span>招标负责人：</span><span>2</span></div>
        <div><span>手机：</span><span>成都公司</span></div>
        <div><span>公司座机：</span><span>成都公司</span></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Icon from './sing-up-status';
import recruitTitle from './recruit-title';
import { getUrlParams } from 'common/js/mUtils';

export default {
  data() {
    return {
      name: '报名中'
    };
  },
  components: {
    Icon,
    recruitTitle
  },
  created() {
    let { winningGuid } = this.$route.query;
    let { id } = getUrlParams();
    if (!winningGuid) {
      winningGuid = id;
    }
    this.$api.getWinBiddingInfo({ winningGuid }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        this.body = body;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
$color-style-666: #666;
$color-style-333: #333;
$color-style-000: #000;
$font-size-26: 26px;
$font-size-28: 28px;
.tending-notice-detail {
  background: #efefef;

  .title-wrap {
    // height: 178px;
    border-bottom: #efefef 1px solid;
    padding: 32px;
    padding-right: 0px;
    background: #fff;
    .subtitle-wrap {
      display: flex;
      .title {
        flex: auto;
        padding-right: 10px;
        color: #000;
        font-size: 32px;
        font-weight: 500;
      }
      .icon {
        width: 120px;
        font-size: 22px;
        font-weight: 400;
        line-height: 2;
      }
    }
    .pubdate-wrap {
      font-size: $font-size-26;
      margin-top: 22px;
      .date {
        span:nth-child(1) {
          color: $color-style-666;
        }
        span:nth-child(2) {
          color: $color-style-333;
        }
      }
    }
  }
  .register-wrap {
    padding: 20px 32px;
    background: #fff;
    > div {
      line-height: 1.8;
      font-size: $font-size-26;
      span:nth-child(1) {
        color: $color-style-666;
      }
      span:nth-child(2) {
        color: $color-style-333;
      }
    }
  }
  .detail {
    margin-top: 20px;
    background: #fff;
    .detail-rest {
      padding: 20px 50px 40px 32px;
      line-height: 1.5;
      .title {
        font-size: $font-size-28;
        margin-bottom: 30px;
        line-height: 2;
      }
      .item {
        line-height: 1.5;
        color: $color-style-000;
        font-size: $font-size-28;
        font-weight: 400;
      }
    }
  }
  .contract {
    margin-top: 20px;
    background: #fff;
    .contract-info {
      padding: 20px 0px 20px 32px;
      div:nth-child(2) {
        margin: 20px 0px;
      }
      div {
        font-size: $font-size-26;
      }
      div span:nth-child(1) {
        color: $color-style-666;
      }
      div span:nth-child(2) {
        color: $color-style-000;
      }
    }
  }
}
</style>
